import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthService, CustomSnackBarService } from "@i7/shared";

@Injectable()
export class AuthSemMenuGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: CustomSnackBarService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    return this.authService.isLoggedIn.pipe(
      take(1),

      map((isLoggedIn: boolean) => {

        if (!isLoggedIn) {          
          this.router.navigate(["/public/sign-in"]);
          return false;
        }
        
        if (this.authService.isTokenExpired()) {
          this.authService.logout();
          this.snackBar.openSnackBar(
            "Sua sessão expirou, faça o login novamente.",
            null,
            "Warn"
          );
          return false;
        }
        this.authService.renewToken();
        return true;
      })
    );
  }
}
